import { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const ChangePhoneWithEmailLazy = lazyLoader(
  () =>
    import(
      './ChangePhoneWithEmail' /* webpackChunkName: "change-phone-email" */
    ),
);

const ChangePhonePhoneWithEmail = () => {
  return (
    <Suspense fallback={null}>
      <ChangePhoneWithEmailLazy />
    </Suspense>
  );
};

export default ChangePhonePhoneWithEmail;
